/**
 * A place for all VeeValidate customizations
 */

import { required, email, min, max, alpha_spaces, numeric } from 'vee-validate/dist/rules';
import { extend, setInteractionMode } from 'vee-validate';

export default {
    install(Vue, options) {
        setInteractionMode('passive');
        extend('min', min);
        extend('max', {
            ...max,
            message: (field, args) => {
                return `The ${field} is not valid. ${field} should be less than ${args.length} characters.`;
            },
        });
        extend('email', email);
        extend('alpha_spaces', alpha_spaces);
        extend('numeric', numeric);
        extend('required', {
            ...required,
            message: 'Required field.',
        });

        extend('valid_name', (value) => {
            const condition = /[\\\/:*?"<>|',;]/;

            if (condition.test(value)) return `Field contains invalid characters. Invalid characters are: \ / : * ? " < > | ' , ;`;

            return true;
        });

        extend('password', (value) => {
            const conditions = {
                specialChars: /[!@#$%^&*]/,
                lowercase: /[a-z]/,
                uppercase: /[A-Z]/,
                numbers: /[0-9]/,
            };
            const tests = [];

            Object.values(conditions).forEach((condition) => {
                tests.push(value.match(condition));
            });

            const hasPassedConditions = tests.filter((test) => test === null).length <= 1;

            return value.length >= 8 && hasPassedConditions;
        });

        extend('tel', (value) => {
            return Boolean(value.match(/^[0-9\s\-\+\\\(\)\.]+$/));
        });
    },
};
